export default {
  getCurrentRow: (state) => {
    return state.currentRow
  }
}
